import React, { useState, useEffect } from "react";
import { ConfigProvider, DatePicker, Space } from "antd";
import { BsCalendarDate } from "react-icons/bs";
import { GrFormNextLink } from "react-icons/gr";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import type { TimeRangePickerProps } from "antd";
import moment from "moment";

const { RangePicker } = DatePicker;

interface Props {
  id: string;
  title: string;
  name: string;
  disable?: boolean;
  dates: any;
  onSelectChange: (e: any, f: any) => void;
  isFullWidth: boolean;
  showIcon?: boolean;
}

export const SelectDate = (props: Props) => {
  const { t } = useTranslation(["translation"]);
  const [dates, setDates] = useState<any>(props.dates);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    setDates(props.dates);
  }, [props.dates]);
  const handleScroll = (e: any) => {
    setIsOpen(false);
  };
  useEffect(() => {
    if (!isOpen && dates !== props.dates) {
      props.onSelectChange(dates, props.name);
    }
  }, [isOpen]);

  // const rangePresets: TimeRangePickerProps["presets"] = [
  //   { label: "Today", value: [dayjs(), dayjs().endOf("day")] },
  //   {
  //     label: "This Month",
  //     value: [dayjs().startOf("month"), dayjs().endOf("month")],
  //   },
  //   {
  //     label: "This Year",
  //     value: [dayjs().startOf("year"), dayjs().endOf("year")],
  //   },
  // ];

  return (
    <div
      className="filter-select-container"
      style={
        props.isFullWidth
          ? { paddingLeft: "0", width: "100%" }
          : { paddingLeft: "24px" }
      }
    >
      {props.showIcon === undefined && (
        <BsCalendarDate
          className={"date-icon"}
          style={props.isFullWidth ? { left: "15px" } : undefined}
        />
      )}
      {props.showIcon !== false && (
        <BsCalendarDate
          className={"date-icon"}
          style={props.isFullWidth ? { left: "15px" } : undefined}
        />
      )}
      <RangePicker
        open={isOpen}
        style={
          props.isFullWidth
            ? {
                height: "100%",
                width: "100%",
                borderTopRightRadius: 6,
                borderBottomRightRadius: 6,
                borderColor: "#ced4da",
              }
            : undefined
        }
        onOpenChange={(e: any) => setIsOpen(e)}
        className={"custom-date"}
        value={props.dates}
        suffixIcon={null}
        placeholder={[t("Start date"), t("End date")]}
        separator={<GrFormNextLink />}
        onCalendarChange={(val) => setDates(val)}
        onChange={(date) => {
          if (!date && dates !== date) {
            props.onSelectChange(date, props.name);
          }
        }}
        ranges={{
          Today: [moment(), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "This Year": [moment().startOf("year"), moment().endOf("year")],
        }}
      />
    </div>
  );
};
